import "core-js/modules/es6.regexp.match";
import _slicedToArray from "/Users/dlynch/code/websites/mathapedia.com/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.for-each";
import React from 'react';
import * as d3 from 'd3';
import { psgraph } from 'latex2js-pstricks';
export default (function (_ref) {
  var env = _ref.env,
      slider = _ref.slider,
      svgRef = _ref.svgRef,
      plot = _ref.plot;
  var latex = slider.latex,
      scalar = slider.scalar,
      variable = slider.variable,
      value = slider.value,
      min = slider.min,
      max = slider.max;

  var onChange = function onChange(event) {
    // update value
    var val = event.target.value / scalar;
    env.variables[variable] = val; // update svg

    var svg = d3.select(svgRef.current);
    svg.selectAll('.psplot').remove();
    Object.entries(plot).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          k = _ref3[0],
          plot = _ref3[1];

      if (k.match(/psplot/)) {
        plot.forEach(function (data) {
          var d = data.fn.call(data.env, data.match);

          if (psgraph[k] && d && svg) {
            psgraph[k].call(d, svg);
          }
        });
      }
    });
  };

  return (
    /*#__PURE__*/
    React.createElement("label", null, latex,
    /*#__PURE__*/
    React.createElement("input", {
      type: "range",
      min: min * scalar,
      max: max * scalar,
      defaultValue: value,
      onChange: onChange
    }))
  );
});